<template>
  <div>
    <Button @click="add" type="primary">新建栏目</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/recommendChannel"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        keyField="id"
        selectType
        method="get"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onEdit(row)">编辑栏目</Button>
            <span>-</span>
            <Button
              type="text"
              size="small"
              :to="{name: goWhere(row.type), query:{id: row.id,type:row.type}}"
            >设置推荐</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onDelete(row)">删除</Button>
          </div>
        </template>
      </Grid>
    </div>
    <Modal class="modal" v-model="modal.show" :title="modal.title" width="500">
      <Form ref="recomment" :model="recomment" :rules="recommentRule" :label-width="120">
        <FormItem label="栏目类型">
          <Select v-if="!modal.id" placeholder="请选择" v-model="recomment.type">
            <Option
              v-for="(item,index) in type_name"
              :value="item.key"
              :key="index"
            >{{ item.value }}</Option>
          </Select>
          <span v-else>{{modal.type_name}}</span>
        </FormItem>
        <FormItem label="栏目顺序" prop="sort">
          <Input type="number" v-model="recomment.sort" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="栏目名称" prop="name">
          <Input v-model="recomment.name" placeholder="请输入" clearable />
        </FormItem>
      </Form>
      <div slot="footer" style="text-align:center;">
        <Button type="primary" size="large" @click="onModalOk" style="width:100px;">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import * as enums from "@/utils/enums";
export default {
  name: "MobileRecomment",
  data() {
    return {
      classify_id: this.$route.query.id,
      tableColumns: [
        { title: "栏目名称", key: "name", align: "center", minWidth: 160 },
        { title: "栏目类型", key: "type_name", align: "center", minWidth: 120 },
        { title: "顺序", key: "sort", align: "center", minWidth: 100 },
        { title: "创建人", key: "username", align: "center", minWidth: 140 },
        {
          title: "创建时间",
          key: "created_at",
          align: "center",
          minWidth: 160
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 180,
          fixed: "right"
        }
      ],
      modal: {
        show: false,
        title: "",
        id: ""
      },
      content: "",
      type_name: enums.MobileRecomment.getOptions(),
      recommentRule: {
        sort: [
          {
            required: true,
            message: "请输入"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入"
          }
        ]
      },
      recomment: {
        type: "1",
        sort: "",
        name: "",
        reset: function() {
          this.type = "1";
          this.sort = "";
          this.name = "";
        }
      },
      searchCondition: {
        classify_id: this.$route.query.id
      }
    };
  },
  methods: {
    goWhere(type) {
      let name = "";
      switch (type) {
        case 1:
          name = "SetCourse";
          break;
        case 2:
          name = "SetVip";
          break;
        case 3:
          name = "SetTeacher";
          break;
        case 5:
          name = "SetNews";
          break;
        case 6:
          name = "SetBook";
          break;
        case 7:
          name = "SetExercise";
          break;
        case 8:
          name = "SetExercise";
          break;
        default:
          name = "SetReservation";
          break;
      }
      return name;
    },
    onrowsFormatter(rows) {
      rows.forEach(i => {
        i.type_name = enums.MobileRecomment.getValue(i.type);
        i.created_at = this.$pub.timestampToTime(i.created_at);
      });
    },
    onEdit(row) {
      for (let i in this.recomment) {
        if (i != "reset") {
          this.recomment[i] = row[i];
        }
      }
      this.modal.show = true;
      this.modal.title = "编辑栏目";
      this.modal.id = row.id;
      this.modal.type_name = row.type_name;
      this.modal.classify_id = row.classify_id;
    },
    add() {
      this.recomment.reset();
      this.modal.show = true;
      this.modal.title = "新增栏目";
      this.modal.id = "";
      this.modal.classify_id = this.classify_id;
    },
    onModalOk() {
      this.$refs.recomment.validate(valid => {
        if (valid) {
          if (this.modal.id) {
            this.$http
              .put("/api/recommendChannel/" + this.modal.id, {
                name: this.recomment.name,
                sort: this.recomment.sort
              })
              .then(() => {
                this.$Message.success("成功");
                this.search();
              });
          } else {
            this.$http
              .post("/api/recommendChannel", {
                name: this.recomment.name,
                sort: this.recomment.sort,
                classify_id: this.classify_id,
                type: this.recomment.type
              })
              .then(() => {
                this.$Message.success("成功");
                this.search();
              });
          }
          this.modal.show = false;
        } else {
          this.$Message.error("请填写完整!");
        }
      });
    },
    search() {
      this.$refs.grid.searchRefresh();
    },
    onDelete(row) {
      this.$Modal.confirm({
        title: "提示",
        content: "确定删除该栏目吗？",
        onOk: () => {
          this.$http.delete("/api/recommendChannel/" + row.id).then(() => {
            this.$Message.success("删除成功!");
            this.search();
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.Detail {
  min-height: 200px;
}
</style>
